import { isFalsy } from '@core/helpers/boolean';
import { sendPixelTrackingWithSession, } from '@core/tracking';
/**
 * Gets interactions by type from an array of interactions
 */
export function getInteractionsByType(interactions, type) {
    return interactions.filter((interaction) => interaction.interaction_type === type);
}
/**
 * Gets interactions by id from an array of interactions
 */
export function idsToInteractions(idArr, interactionArr) {
    if (!idArr || !interactionArr || !idArr.length || !interactionArr.length) {
        return [];
    }
    return idArr
        .map((id) => interactionArr.find((interaction) => interaction.id === id))
        // We assert the type because compiler
        // can't infer that the array is filtered
        // IDE doesn't flag, but build fails
        .filter((i) => i !== undefined);
}
/**
 * Builds the properties for tracking events related to interaction pills.
 * @param interaction
 * @param params
 * @param video
 * @returns
 */
export function getInteractionTrackingEventProperties(interaction, params, video) {
    if (!params || !video) {
        return undefined;
    }
    return {
        _livestream_id: video.live_stream_id,
        _video_id: video.encoded_id,
        _channel_id: video.creator.encoded_id,
        _playlist_id: params.playlist,
        live_stream_status: video.live_stream_status,
        _interaction_id: interaction?.id,
        interaction_type: interaction?.interaction_type,
    };
}
/**
 * Sends pixel tracking with session data for interaction pills.
 */
export function sendInteractionPixelTrackingWithSession(endpoint, interaction, params, video, extra = {}) {
    const eventProperties = getInteractionTrackingEventProperties(interaction, params, video);
    if (!eventProperties) {
        return Promise.reject(isFalsy(video) ? 'Video is not defined' : 'Params are not defined');
    }
    return sendPixelTrackingWithSession({
        endpoint,
        host: params?.api_host_tracking,
        data: {
            event_properties: {
                ...eventProperties,
                ...extra,
            },
        },
    });
}
